export enum ErrorCorrectionLevel {
    L = 'L',
    M = 'M',
    Q = 'Q',
    H = 'H',
}

export enum Environment {
    production = 'production',
    staging = 'staging',
}

export enum ThemePreset {
    light = 'light',
    dark = 'dark',
}
